import { FunctionComponent, memo, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { FeaturedCard } from './FeaturedCard';

import classes from './FeaturedCards.module.scss';

interface ConfigFeaturedCard {
  storyId: number;
  cardId: number;
}

export interface ConfigFeaturedCardsWidget {
  titleLocaliseKey?: string;
  items: ConfigFeaturedCard[];
}

interface FeaturedCardsProps {
  config: ConfigFeaturedCardsWidget;
}

export const FeaturedCards: FunctionComponent<FeaturedCardsProps> = memo(({ config }) => {
  const { t } = useTranslation();

  const { titleLocaliseKey, items } = config;

  const [loadedCount, setLoadedCount] = useState(0);

  const onLoaded = useCallback(() => {
    setLoadedCount((loadedCountPrev) => loadedCountPrev + 1);
  }, []);

  if (!items.length) {
    return null;
  }

  return (
    <div className={classes['featured-cards']}>
      {titleLocaliseKey && (
        <h2 className={classes['featured-cards__title']}>{t(titleLocaliseKey)}</h2>
      )}
      {loadedCount < items.length && (
        <Skeleton className={classes['featured-cards__cards-loader']} count={items.length} />
      )}
      {items.map(({ storyId, cardId }) => (
        <FeaturedCard
          key={`${storyId}-${cardId}`}
          storyId={storyId}
          cardId={cardId}
          onLoaded={onLoaded}
        />
      ))}
    </div>
  );
});
